import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Alert,
  CardBody,
  Button,
  Label,
  Input,
  FormFeedback,
  Form,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import withRouter from "components/Common/withRouter";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";

import avatar from "../../assets/images/users/avatar-1.jpg";
// actions
import { editProfile, resetProfileFlag } from "../../store/actions";
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const UserProfile = () => {

  //meta title
  document.title = "Profile | Definite Assurance Company LTD";

  const dispatch = useDispatch();

  const [email, setEmail] = useState("");
  const [name, setName] = useState("");
  const [pin, setPin] = useState('')
  const [phone, setPhone] = useState('')
  const [id, setId] = useState('');
  const [saveText, setSavetext] = useState('Save Changes')
    const [credentials, setCredentials] = useState(null)
    const [isAuth, setIsauth] = useState(false)
    const company = 'Definite'
  
    useEffect(()=>{
    const getCredentials =async()=>{
      const res = await fetch(`https://digitalapi.definiteassurance.com/api/getCredentials?username=${company}`)
      const data = await res.json();
      const {Username, Password} = data;
      const cred = btoa(`${Username}:${Password}`)
      setCredentials(btoa(`${Username}:${Password}`))
      setIsauth(true)
  
  
    }
    getCredentials()
  
    },[])

      useEffect(() => {
        const user = localStorage.getItem('definiteagent'); // Retrieve email
        if (user) {
           setEmail(user)
        } else {
       
        }
      }, []);
  const getDetails =async()=>{
        const res=await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${email}`,{
           method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setName(data.Dealer_name)
        setId(data.IdentificationNo)
        setPhone(data.Mobile)
        setPin(data.Pin)
      }
    useEffect(()=>{
      const getDetails =async()=>{
        const res=await fetch(`https://digitalapi.definiteassurance.com/api/getDealerdetails?email=${email}`,{
           method:"GET",
                headers:{
                  'Authorization': `Basic ${credentials}`,
                  'Content-Type': "application/json"
                }
        });
        const data = await res.json();
        setName(data.Dealer_name)
        setId(data.IdentificationNo)
        setPhone(data.Mobile)
        setPin(data.Pin)
      }

      if(email && isAuth){
        getDetails()
      }
    },[email, isAuth])
  
  const saveChanges = async()=>{
    setSavetext('Please Wait...')
    const res = await fetch(`https://digitalapi.definiteassurance.com/api/updateDealer`,{
      method:"POST",
      headers:{
        'Authorization': `Basic ${credentials}`,
        'Content-Type': "application/json"
      },
      body:JSON.stringify({email,name,phone}),
      credentials:"include"
    })

    const data = await res.json();
    const {success} = data;
    if(success){
      getDetails()
      setSavetext('Save changes')
      toast.success('Changes saved successfully')
    }
    else{
      setSavetext('Save changes')
      toast.error('Failed! Somthing went wrong!')
    }
  }


  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title="Definite Assurance" breadcrumbItem="Profile" />

          <Row>
            <Col lg="12">
            

              <Card>
                <CardBody>
                  <div className="d-flex">
                    <div className="ms-3">
                      <img
                        src='/usericon.png'
                        alt=""
                        className="avatar-md rounded-circle img-thumbnail"
                      />
                    </div>
                    <div className="flex-grow-1 align-self-center" >
                      <div className="text-muted" style={{marginLeft:'20px'}}>
                        <h5>{name}</h5>
                        <p className="mb-1"><strong>Agency name:</strong> {name}</p>
                        <p className="mb-1"><strong>Email:</strong> {email}</p>
                         <p className="mb-1"><strong>Phone:</strong> {phone}</p>
                         <p className="mb-1"><strong>ID:</strong> {id}</p>
                         <p className="mb-1"><strong>KRA PIN:</strong> {pin}</p>
                      </div>
                    </div>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>

          <h4 className="card-title mb-4">Change User Name</h4>

          <Card>
            <CardBody>

                <div className="forminputs3">
                        <div id="profileInput" className="form-group">
                        <Label className="form-label">User Name</Label>
                        <Input
                          name="username"
                          // value={name}
                          className="form-control"
                          value={name}
                          type="text"
                          disabled
                        />
                        </div>

                        <div id="profileInput" className="form-group">
                        <Label className="form-label">Phone Number</Label>
                        <Input
                          name="username"
                          // value={name}
                          className="form-control"
                          value={phone}
                          type="text"
                          disabled
                        />
                 
                 
                        </div>
                 
                 
          
                </div>




                <div className="text-center mt-4">
                  <Button  color="success">
                    Save Changes
                  </Button>
                </div>
             
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
